import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

const GoogleIcon = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" {...props}>
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1Z" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23Z" />
    <path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84Z" />
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1A11 11 0 0 0 2.18 7.06l3.66 2.84C6.71 7.3 9.14 5.38 12 5.38Z" />
  </svg>
);

const MicrosoftIcon = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" {...props}>
    <path fill="#F25022" d="M3 3h8.5v8.5H3z" />
    <path fill="#7FBA00" d="M12.5 3H21v8.5h-8.5z" />
    <path fill="#00A4EF" d="M3 12.5h8.5V21H3z" />
    <path fill="#FFB900" d="M12.5 12.5H21V21h-8.5z" />
  </svg>
);

export const SocialAuthButtons = ({ label = "Or continue with" }) => {
  const { signInWithProvider } = useAuth();
  const [pending, setPending] = useState(null);

  const go = async (provider) => {
    setPending(provider);
    const { error } = await signInWithProvider(provider);
    if (error) {
      setPending(null);
      toast.error(error.message || "Sign-in failed. Is this provider enabled in Supabase?");
    }
    // On success the browser redirects to the provider; no further action here.
  };

  const Btn = ({ provider, icon, text, testId }) => (
    <button
      type="button"
      onClick={() => go(provider)}
      disabled={!!pending}
      data-testid={testId}
      className="inline-flex w-full items-center justify-center gap-2.5 rounded-md border border-slate-300 bg-white px-4 py-2.5 text-sm font-medium text-slate-700 transition-all duration-200 hover:bg-slate-50 disabled:opacity-60"
    >
      {pending === provider ? <Loader2 className="h-4 w-4 animate-spin" /> : icon}
      {text}
    </button>
  );

  return (
    <div className="space-y-4" data-testid="social-auth-buttons">
      <div className="flex items-center gap-3">
        <div className="h-px flex-1 bg-slate-200" />
        <span className="text-xs uppercase tracking-wide text-slate-400">{label}</span>
        <div className="h-px flex-1 bg-slate-200" />
      </div>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <Btn provider="google" icon={<GoogleIcon />} text="Google" testId="oauth-google-button" />
        <Btn provider="azure" icon={<MicrosoftIcon />} text="Microsoft" testId="oauth-microsoft-button" />
      </div>
    </div>
  );
};
